<template>
  <div v-if="test && test.questions">
    <div class="question mt-4" v-if="!isFinal">
      <div class="question__range-bg mt-1 mb-3">
        <div class="range" :style="{ width: calcRangeWidth + '%' }"></div>
      </div>
      <h1 class="pt-2">
        {{ currentQuestion.text }}
      </h1>
      <div
        class="question__conditions"
        v-html="currentQuestion.conditions"
      ></div>
      <div class="question__answers">
        <b-form-input
          placeholder="Введіть текст відповіді"
          v-model="currentAnswer"
          class="mb-4"
        />
        <b-button
          :disabled="!currentAnswer.length"
          variant="primary"
          @click="answerAction"
        >
          Прийняти відповідь
        </b-button>
      </div>
    </div>
    <div class="result text-center py-4" v-if="isFinal">
      <div class="result__header">
        <h1>Тест завершено</h1>
      </div>
      <div class="result__body">
        <h6>
          Ваш результат: <strong>{{ totalScores }}</strong> балів
        </h6>
        <p class="mb-4 mt-2">
          {{ resultText }}
        </p>
        <div class="mb-4">
          <b-button :to="{ name: 'candidate-tests' }" variant="primary">
            До всіх тестів
          </b-button>
        </div>
        <div class="image py-4">
          <img width="300" src="@/assets/img/confirmed.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["test"],
  data() {
    return {
      isLoading: false,
      isFinal: false,
      //Answers
      answers: [],
      currentAnswer: "",
      //Current test by type
      currentQuestionIndex: 0,
    };
  },
  computed: {
    calcRangeWidth() {
      var percentage = 1;
      if (this.currentQuestionIndex != 0) {
        percentage =
          (this.currentQuestionIndex / this.test.questions.length) * 100;
      }

      if (this.currentQuestionIndex == this.test.questions.length - 1) {
        percentage = 98;
      }

      return percentage;
    },
    resultText() {
      let text = "Немає результату";
      let grades = this.test.grades;
      for (var i = 0; i < grades.length; i++) {
        if (this.totalScores >= grades[i].min_points) {
          text = grades[i].description;
        }
      }

      return text;
    },
    totalScores() {
      let total = 0;
      total = this.answers.reduce((partialSum, a) => partialSum + a, 0);

      return total;
    },
    currentQuestion() {
      let question;
      if (this.test.questions && this.test.questions.length) {
        question = this.test.questions[this.currentQuestionIndex];
      }
      return question;
    },
  },
  methods: {
    answerAction() {
      if (
        this.currentAnswer.toLowerCase().trim() ==
        this.currentQuestion.answer.toLowerCase().trim()
      ) {
        this.answers.push(Number(this.currentQuestion.points));
      } else {
        this.answers.push(0);
      }
      this.currentAnswer = "";
      if (this.currentQuestionIndex + 1 < this.test.questions.length) {
        this.currentQuestionIndex++;
      } else {
        this.isFinal = true;
        let results = {
          scores: this.totalScores,
          text: this.resultText,
        };
        this.$emit("finish", results);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.result {
  &__header {
    h1 {
      color: rgb(0, 128, 49);
    }
  }
}
.question {
  &__conditions {
    font-size: 1.5em;
    color: var(--primary-color);
  }
  &__range-bg {
    background-color: #999;
    position: relative;
    height: 4px;
    .range {
      min-width: 5px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      background: var(--secondary-color);
      transition: 0.8s;
      max-width: 100%;
    }
  }
  &__answers {
    width: 540px;
    max-width: 100%;
    .answer {
      .btn {
        padding-left: 36px !important;
        position: relative;
        background: var(--primary-color);
        border: none !important;
        strong {
          margin-right: 10px;
          opacity: 1;
          position: absolute;
          left: 10px;
          color: var(--secondary-color) !important;
        }
        &:active {
          background: var(--secondary-color) !important;
          color: var(--primary-color) !important;
          strong {
            color: var(--primary-color) !important;
          }
        }
      }
    }
  }
}
</style>
